import { setRatioFormat } from 'modules/ratioFormat';
import { takeEvery } from 'redux-saga/effects';
import { getType } from 'deox';

export function* setRatioFormatSaga(_: ReturnType<typeof setRatioFormat>) {}

export default function* ratioFormatSaga() {
  yield takeEvery(getType(setRatioFormat), setRatioFormatSaga);
}
